/**
 * Noop for browser compatibility
 */
export function setMaxListeners (): void {}
